import { Languages } from "lucide-react";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "../Button";

import { LANGS_VALUES, TLangsValues } from "../../../modules/i18n/consts";
import { cn } from "../../../utils";
import { useStore } from "../../../store/store";
import { Dropdown, DropdownItem } from "flowbite-react";

export function LangToggler() {
  const { t, i18n } = useTranslation("common", { keyPrefix: "lang" });
  const brandingList = useStore((state) => state.brandingList);

  const [currentLang, setCurrentLang] = useState<TLangsValues>(
    i18n.resolvedLanguage as TLangsValues,
  );

  useEffect(() => {
    async function changeLanguage(lang: TLangsValues) {
      await i18n.changeLanguage(lang);
    }

    changeLanguage(currentLang).catch(console.error);
  }, [currentLang, i18n]);

  useEffect(() => {
    if (
      brandingList?.default_language &&
      LANGS_VALUES.includes(brandingList.default_language as TLangsValues)
    ) {
      setCurrentLang(brandingList.default_language as TLangsValues);
    }
  }, [brandingList?.default_language]);

  return (
    <>
      <Dropdown
        size="sm"
        className="text-foreground"
        arrowIcon={false}
        data-testid="lang-toggler"
        renderTrigger={() => (
          <Button
            variant="ghost"
            size="icon"
            id="lang-toggler-button"
            data-testid="lang-toggler-button"
          >
            <Languages className="icon" />
            <span className="sr-only">{t("ICON_LABEL")}</span>
          </Button>
        )}
        label=""
      >
        {LANGS_VALUES.map((lang) => (
          <DropdownItem
            key={lang}
            onClick={() => setCurrentLang(lang)}
            className={cn(
              lang === currentLang ? "text-primary" : "",
              currentLang === "ar" ? "justify-end" : "justify-start",
            )}
          >
            {t(lang)}
          </DropdownItem>
        ))}
      </Dropdown>
    </>
  );
}
